import * as z from "zod";

export const VariantExchangeRecommendationsSchema = z.object({
  recommendedOptions: z.array(
    z.object({ name: z.string(), values: z.array(z.string()) }),
  ),
  recommendationTitle: z.string().optional(),
  recommendationSubtitle: z.string().optional(),
  outOfStockApology: z.string().optional(),
});
export type VariantExchangeRecommendations = z.infer<
  typeof VariantExchangeRecommendationsSchema
>;
